import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "product-detail-wrapper"
};
const _hoisted_2 = {
  class: "product-detail-page"
};
const _hoisted_3 = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_4 = {
  key: 1,
  class: "detail-content"
};
const _hoisted_5 = {
  class: "right-content"
};
const _hoisted_6 = {
  class: "page-title"
};
const _hoisted_7 = {
  key: 0,
  class: "publish-time"
};
const _hoisted_8 = {
  key: 1,
  class: "product-image"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  class: "section"
};
const _hoisted_11 = {
  class: "intro-content"
};
const _hoisted_12 = {
  class: "section"
};
const _hoisted_13 = {
  class: "params-content"
};
const _hoisted_14 = {
  class: "back-btn-wrapper"
};
const _hoisted_15 = {
  key: 2,
  class: "empty-wrapper"
};
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getProductById } from '@/api/product';
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDetail',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const productDetail = ref(null);
    const loading = ref(true);
    // 根据来源路由动态设置面包屑和菜单激活项
    const activeMenuId = computed(() => {
      const from = route.query.from;
      return from || 'swyy';
    });
    const breadcrumbItems = computed(() => {
      const from = route.query.from;
      let categoryLabel = '生物医药';
      let categoryPath = '/swyy';
      // 可以根据不同的来源设置不同的面包屑
      if (from === 'bdtcl') {
        categoryLabel = '半导体测量';
        categoryPath = '/bdtcl';
      } else if (from === 'gpyq') {
        categoryLabel = '光谱仪器';
        categoryPath = '/gpyq';
      } else if (from === 'gmjt') {
        categoryLabel = '光密镜头';
        categoryPath = '/gmjt';
      }
      return [{
        label: '首页',
        path: '/'
      }, {
        label: '产品服务'
      }, {
        label: categoryLabel,
        path: categoryPath
      }, {
        label: '详情'
      }];
    });
    const fetchProductDetail = async id => {
      try {
        loading.value = true;
        const res = await getProductById(id);
        if (res.data) {
          productDetail.value = res.data;
        }
      } catch (error) {
        console.error('获取产品详情失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const goBack = () => {
      router.go(-1);
    };
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    };
    onMounted(() => {
      const id = route.params.id;
      if (id) {
        fetchProductDetail(Number(id));
      }
    });
    return (_ctx, _cache) => {
      const _component_Breadcrumb = _resolveComponent("Breadcrumb");
      const _component_SideMenu = _resolveComponent("SideMenu");
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Breadcrumb, {
        items: breadcrumbItems.value
      }, null, 8, ["items"]), _createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : productDetail.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_SideMenu, {
        activeId: activeMenuId.value
      }, null, 8, ["activeId"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(productDetail.value.name), 1), productDetail.value.publishTime ? (_openBlock(), _createElementBlock("div", _hoisted_7, "发布时间：" + _toDisplayString(formatDate(productDetail.value.publishTime)), 1)) : _createCommentVNode("", true), productDetail.value.productImage ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
        src: productDetail.value.productImage,
        alt: productDetail.value.name
      }, null, 8, _hoisted_9)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createVNode(_component_SectionTitle, {
        title: "产品介绍",
        "show-more": false
      }), _createElementVNode("div", _hoisted_11, _toDisplayString(productDetail.value.introduce), 1)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_SectionTitle, {
        title: "主要参数",
        "show-more": false
      }), _createElementVNode("div", _hoisted_13, _toDisplayString(productDetail.value.majorParameter), 1)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
        onClick: goBack
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("返回列表", -1)]))]),
        _: 1
      })])])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无产品详情", -1)]))]))]), _createVNode(_component_Footer)]);
    };
  }
});